import Lottie from 'lottie-react'
// import loadingLottie from '@/assets/lottie/spark.json'
import loadingLottie from '@/assets/lottie/loading.json'

const LoadingScreen = () => {
  return (
    <div className='min-h-screen bg-white'>
      {/* 로딩 콘텐츠 */}
      <div className='flex flex-col items-center justify-center min-h-[calc(100vh-128px)] px-6'>
        <div className='text-center mb-16'>
          <h1 className='text-2xl font-bold text-amber-900 mb-4'>리포트를 생성중입니다.</h1>
          <p className='text-xl text-amber-800'>잠시만 기다려주세요!</p>
        </div>

        {/* loading 애니메이션 */}
        <div className='relative'>
          <Lottie className='w-45 h-45' animationData={loadingLottie} loop={true} />
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen
